<template lang="pug">
  ods-dropdown(
    :hide-on-click='false'
    icon='setting'
    @visible-change='handleVisibleChange')
    ods-dropdown-menu.popover-columns.desplegable(slot='dropdown')
      h3.titulosetting {{ $t('msg_generics.filter_table_menu') }}
      ods-dropdown-item(
        v-for='(column, index) in columns',
        :key='index')
        ods-checkbox(
          @input='handlerShowColumns(column)',
          v-model='column.show')
          | {{ column.text }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'b2b-table-menu-auditorias',
  props: [],
  data () {
    return {
      columns: [],
      column: {}
    }
  },
  computed: {
    ...mapGetters([
      // Columnas Tabla Auditoria de documentos
      'isShowEmisorAuditorias',
      'isShowReceptorAuditorias',
      'isShowFechaAuditorias',
      'isShowNombreAuditorias',
      'isShowNumDocumentoAuditorias',
      'isShowTipoDocumentoAuditorias',
      'isShowEstadoAuditorias',
      'isShowServicioAuditorias',
      'isShowComunicacionAuditorias',
      'isShowModuleAuditorias',
      'isShowLoteAuditorias',
      'isShowProcessingTimeAuditorias',
      'optionsFilterService',
      'canAdminIndra'
    ])
  },
  methods: {
    ...mapActions([
      // Columnas Tabla Auditoria de documentos
      'isShowEmisorAuditoriasAction',
      'isShowReceptorAuditoriasAction',
      'isShowFechaAuditoriasAction',
      'isShowNombreAuditoriasAction',
      'isShowNumDocumentoAuditoriasAction',
      'isShowTipoDocumentoAuditoriasAction',
      'isShowEstadoAuditoriasAction',
      'isShowServicioAuditoriasAction',
      'isShowComunicacionAuditoriasAction',
      'isShowModuleAuditoriasAction',
      'isShowLoteAuditoriasAction',
      'isShowProcessingTimeAuditoriasAction'
    ]),

    handlerShowColumns (col) {
      const column = col.value
      let isShow
      switch (column) {
        case 'emisor':
          isShow = !this.isShowEmisorAuditorias
          this.isShowEmisorAuditoriasAction(isShow)
          break
        case 'receptor':
          isShow = !this.isShowReceptorAuditorias
          this.isShowReceptorAuditoriasAction(isShow)
          break
        case 'fecha':
          isShow = !this.isShowFechaAuditorias
          this.isShowFechaAuditoriasAction(isShow)
          break
        case 'nombre':
          isShow = !this.isShowNombreAuditorias
          this.isShowNombreAuditoriasAction(isShow)
          break
        case 'num-documento':
          isShow = !this.isShowNumDocumentoAuditorias
          this.isShowNumDocumentoAuditoriasAction(isShow)
          break
        /*
        case 'tipo-documento':
          isShow = !this.isShowTipoDocumentoAuditorias
          this.isShowTipoDocumentoAuditoriasAction(isShow)
          break
        */
        case 'estado':
          isShow = !this.isShowEstadoAuditorias
          this.isShowEstadoAuditoriasAction(isShow)
          break
        case 'servicio':
          isShow = !this.isShowServicioAuditorias
          this.isShowServicioAuditoriasAction(isShow)
          break
        case 'comunicacion':
          isShow = !this.isShowComunicacionAuditorias
          this.isShowComunicacionAuditoriasAction(isShow)
          break
        case 'modulo':
          isShow = !this.isShowModuleAuditorias
          this.isShowModuleAuditoriasAction(isShow)
          break
        case 'lote':
          isShow = !this.isShowLoteAuditorias
          this.isShowLoteAuditoriasAction(isShow)
          break
        case 'processingTime':
          isShow = !this.isShowProcessingTimeAuditorias
          this.isShowProcessingTimeAuditoriasAction(isShow)
          break
        default:
          break
      }
    },
    handleVisibleChange () {
      this.chargeFilters()
    },
    chargeFilters () {
      if (this.canAdminIndra) {
        this.columns = [
          {
            text: this.$t('auditory.auditory_entity_table.sender'), value: 'emisor', show: this.isShowEmisorAuditorias
          }, {
            text: this.$t('auditory.auditory_entity_table.receiver'), value: 'receptor', show: this.isShowReceptorAuditorias
          }, {
            text: this.$t('auditory.auditory_entity_table.date'), value: 'fecha', show: this.isShowFechaAuditorias
          }, {
            text: this.$t('auditory.auditory_entity_table.filename'), value: 'nombre', show: this.isShowNombreAuditorias
          }, {
            text: this.$t('auditory.auditory_entity_table.document_number'), value: 'num-documento', show: this.isShowNumDocumentoAuditorias
          },
          /* {
            text: this.$t('auditory.auditory_entity_table.document_type'), value: 'tipo-documento', show: this.isShowTipoDocumentoAuditorias
          },
          */{
            text: this.$t('auditory.auditory_entity_table.status'), value: 'estado', show: this.isShowEstadoAuditorias
          }, {
            text: this.$t('auditory.auditory_entity_table.project'), value: 'servicio', show: this.isShowServicioAuditorias
          }, {
            text: this.$t('auditory.auditory_entity_table.communication_protocol'), value: 'comunicacion', show: this.isShowComunicacionAuditorias
          }, {
            text: this.$t('auditory.auditory_entity_table.audit_document_module'), value: 'modulo', show: this.isShowModuleAuditorias
          }, {
            text: this.$t('auditory.auditory_entity_table.batch'), value: 'lote', show: this.isShowLoteAuditorias
          }, {
            text: this.$t('auditory.auditory_entity_table.processingTime'), value: 'processingTime', show: this.isShowProcessingTimeAuditorias
          }
        ]
      } else {
        this.columns = [
          {
            text: this.$t('auditory.auditory_entity_table.sender'), value: 'emisor', show: this.isShowEmisorAuditorias
          }, {
            text: this.$t('auditory.auditory_entity_table.receiver'), value: 'receptor', show: this.isShowReceptorAuditorias
          }, {
            text: this.$t('auditory.auditory_entity_table.date'), value: 'fecha', show: this.isShowFechaAuditorias
          }, {
            text: this.$t('auditory.auditory_entity_table.filename'), value: 'nombre', show: this.isShowNombreAuditorias
          }, {
            text: this.$t('auditory.auditory_entity_table.document_number'), value: 'num-documento', show: this.isShowNumDocumentoAuditorias
          },
          /* {
            text: this.$t('auditory.auditory_entity_table.document_type'), value: 'tipo-documento', show: this.isShowTipoDocumentoAuditorias
          },
          */{
            text: this.$t('auditory.auditory_entity_table.status'), value: 'estado', show: this.isShowEstadoAuditorias
          }, {
            text: this.$t('auditory.auditory_entity_table.project'), value: 'servicio', show: this.isShowServicioAuditorias
          }, {
            text: this.$t('auditory.auditory_entity_table.communication_protocol'), value: 'comunicacion', show: this.isShowComunicacionAuditorias
          }, {
            text: this.$t('auditory.auditory_entity_table.audit_document_module'), value: 'modulo', show: this.isShowModuleAuditorias
          }, {
            text: this.$t('auditory.auditory_entity_table.batch'), value: 'lote', show: this.isShowLoteAuditorias
          }
        ]
      }

      // Si el usuario sólo tiene un servicio, quitamos el checkbox de servicios
      if (this.optionsFilterService.length < 2) {
        this.columns.splice(6, 1)
      }
    }
  },
  created () {
    this.chargeFilters()
  }
}
</script>

<style lang="scss" scoped>
.desplegable {
    top: 180px !important
}
.titulosetting {
      padding: 10px;
}
</style>
